// @ts-check
import "../css/main.scss";
import $ from "jquery";
import "jquery-match-height";
import "slick-carousel";
import WOW from "wow.js";
import Cookie from "js-cookie";

$(document).ready(() => {
  $("#bookdirectlink").click(function () {
    $("#bookdirectp").show();
  });

  $(".close").click(function () {
    Cookie.set("popup", "clicked", { expires: 7, path: "/" });
    $("#bookdirectp").hide();
  });

  $(".js-hidden").fadeOut().removeClass("js-hidden").fadeIn();

  //   $(".cookie-message").cookieBar({ closeButton: ".my-close-button" });
  //     $(".cookie-message").on("cookieBar-close", function () {
  //       $(".nav-bar__book").removeClass("with-bar");
  //     });

  //     setTimeout(function () {
  //       if (!$(".cookie-message").is(":visible")) {
  //         $(".nav-bar__book").removeClass("with-bar");
  //       }
  //     }, 200);

  //   $("#accordion1").accordiom({
  //     showFirstItem: false, // Either show or hide the first item when loading
  //   });

  $(".gallery__carousel").slick({
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
  });

  const width = $(window).width();
  if (width >= 775) {
    //Enable MatchHeight on larger screens
    $(".matchHeight").matchHeight({
      byRow: false,
      property: "height",
      target: null,
      remove: false,
    });

    //Enable animations on larger screens
    new WOW().init();
  }

  //   $("#hero__bwpad").pickadate({
  //     min: new Date(),
  //     format: "dd/mm/yyyy",
  //   });

  $(".popup-link").click(function (event) {
    event.preventDefault();
    const target = $(this).data("popup");
    $(".popups").addClass("active");
    $(".popup-box." + target).addClass("active");
    $("body").addClass("no-scroll");
  });

  $(".close-button").click(function () {
    $(".popup-box.active").removeClass("active");
    setTimeout(function () {
      $(".popups").removeClass("active");
    }, 350);
    $("body").removeClass("no-scroll");
  });

  //Scroller listenr to hide header
  $(window).scroll(function () {
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    if (scroll >= 200) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
    }
  });

  // //FB Share page JS
  // $(".fbShare").click(function (event) {
  //     event.preventDefault();
  //     FB.ui(
  //       {
  //         method: "share",
  //         href: window.location.href,
  //       },
  //       function (response) {}
  //     );
  //   });
  //   //FB Share page JS END

  const grSlick = $("#grSlick").slick({
    speed: 300,
    dots: false,
    arrow: true,
    //slidesToShow: 1,
    centerMode: true,
    centerPadding: "10px",
    variableWidth: true,
  });

  $(".gallery-row__slide").click(function () {
    const currentSlide = $(".slick-current").data("slick-index");
    const nextSlide = $(this).data("slick-index");

    if (nextSlide > currentSlide) {
      console.log("Forward a slide!");
      grSlick.slick("slickNext");
    } else if (nextSlide < currentSlide) {
      console.log("Backwards a slide...");
      grSlick.slick("slickPrev");
    }
  });

  $("#ghSlick").slick({
    speed: 300,
    dots: false,
    arrow: true,
    //slidesToShow: 1,
    centerMode: true,
    centerPadding: "0px",
    variableWidth: true,
  });

  $("#pSlick").slick({
    speed: 300,
    dots: false,
    arrow: true,
    //slidesToShow: 1,
    centerMode: true,
    centerPadding: "10px",
    variableWidth: true,
  });

  $("#nav-booking-bar").submit(function (e) {
    e.preventDefault();
    const checkInRaw = $("#hero__bwpad").val();
    const checkIn = checkInRaw.split("/");
    const year = checkIn[2];
    const month = checkIn[1];
    const day = checkIn[0];
    const nights = $("#nights").val();

    const bookingURL =
      "http://fe.avvio.com/convert/site/Norfolk%20Towers%20Paddington/en/results.php?checkin=" +
      year +
      "-" +
      month +
      "-" +
      day +
      "&nights=" +
      nights +
      "&currency=GBP";

    window.location.href = bookingURL;
  });

  $("#popupForm").submit(function (e) {
    e.preventDefault();
    const checkInRaw = $("#popupDate").val();
    const checkIn = checkInRaw.split("/");
    const year = checkIn[2];
    const month = checkIn[1];
    const day = checkIn[0];
    const nights = $("#popupNights").val();

    const bookingURL =
      "http://fe.avvio.com/convert/site/Blakemore%20Hyde%20Park/en/results.php?checkin=" +
      year +
      "-" +
      month +
      "-" +
      day +
      "&nights=" +
      nights +
      "&currency=GBP";

    window.location.href = bookingURL;
  });

  $(".js__openBooking").click(function (e) {
    e.preventDefault();
    $(".popup__booking-widget").toggleClass("active");
  });

  $(".js__openHeroBooking").click(function (evt) {
    evt.preventDefault();
    $("body").addClass("no-scroll"); 
    $(".hero__booking-widget").toggleClass("desktopBookingHidden");
  })

  $(".mobile-booking-popup__close").click(function () {
    $("body").removeClass("no-scroll"); 
    $(".hero__booking-widget").toggleClass("desktopBookingHidden");
  });

  $(".popup__booking-widget .popup-close").click(function () {
    $(".popup__booking-widget").toggleClass("active");
  });

  $(".mobile-nav-popup__open").click(function () {
    $(".mobile-nav-popup").toggleClass("active");
    $("body").addClass("no-scroll");
  });

  $(".mobile-nav-popup__close").click(function () {
    $(".mobile-nav-popup").toggleClass("active");
    $("body").removeClass("no-scroll");
  });

  // Scroll to top btn
  $(".to-the-top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 800);
    return false;
  });

  // // make scroll down btn appear
  // var waypoint = new Waypoint({
  //     element: document.getElementById("show-menu-waypoint"),
  //     handler: function () {},
  //   });

  //   // hide/show scroll down btn
  //   var waypoint = new Waypoint({
  //     element: document.getElementById("show-menu-waypoint"),
  //     handler: function (direction) {
  //       //console.log(direction);
  //       if (direction == "up") {
  //         $(".to-the-top").fadeOut();
  //       } else {
  //       }
  //       if (direction == "down") {
  //         $(".to-the-top").fadeIn();
  //       } else {
  //       }
  //     },
  //   });

  $(".home-slick ul").slick();
});
